import { useId } from 'react'
import { Alert } from '../common/Alert'
import { ChangeSet } from './ChangeSet'
import { ContextReferenceList } from './ContextReferenceList'
import styles from './DecisionReview.module.css'

export function DecisionReview({
  title = 'Review changes',
  description,
  contextItems = [],
  contextTitle = 'Review context',
  changeItems = [],
  changeTitle = 'Proposed changes',
  changeDescription,
  consequence,
  consequenceTitle = 'What happens next',
  error,
  actions,
  className = '',
}) {
  const titleId = useId()
  const consequenceId = useId()

  return (
    <section className={[styles.root, className].filter(Boolean).join(' ')} aria-labelledby={titleId}>
      <header className={styles.header}>
        <h2 id={titleId}>{title}</h2>
        {description ? <p>{description}</p> : null}
      </header>

      <ContextReferenceList items={contextItems} title={contextTitle} />
      <ChangeSet items={changeItems} title={changeTitle} description={changeDescription} />

      {consequence ? (
        <section className={styles.consequence} aria-labelledby={consequenceId}>
          <h3 id={consequenceId}>{consequenceTitle}</h3>
          {typeof consequence === 'string' ? <p>{consequence}</p> : consequence}
        </section>
      ) : null}

      {error ? <Alert variant="error">{error}</Alert> : null}
      {actions ? <footer className={styles.actions}>{actions}</footer> : null}
    </section>
  )
}

export default DecisionReview
